import { Feather, Phone, Mail, MapPin, Facebook } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#081C15] border-t border-white/10 text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-9 h-9 rounded-full bg-[#1B4332] flex items-center justify-center">
              <Feather size={18} className="text-[#D4AF37]" />
            </span>
            <span className="font-display font-extrabold text-lg tracking-tight">
              IMR <span className="text-[#D4AF37]">Poultry Solutions</span>
            </span>
          </div>
          <p className="text-sm text-[#D8E2DC]/80 leading-relaxed max-w-xs">
            Professional poultry barn cleaning and sanitation services.
            Cleaner barns. Stronger farms.
          </p>
        </div>

        <div>
          <h3 className="font-display font-bold text-sm uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Explore</h3>
          <ul className="space-y-2.5 text-sm text-[#D8E2DC]/80">
            <li><a href="#about" data-testid="footer-link-about" className="hover:text-white transition-colors duration-200">About Us</a></li>
            <li><a href="#services" data-testid="footer-link-services" className="hover:text-white transition-colors duration-200">Our Services</a></li>
            <li><a href="#before-after" data-testid="footer-link-before-after" className="hover:text-white transition-colors duration-200">Before &amp; After</a></li>
            <li><a href="#why-imr" data-testid="footer-link-why" className="hover:text-white transition-colors duration-200">Why Choose IMR</a></li>
            <li><a href="#industry" data-testid="footer-link-industry" className="hover:text-white transition-colors duration-200">Industry Information</a></li>
            <li><a href="#contact" data-testid="footer-link-contact" className="hover:text-white transition-colors duration-200">Contact Us</a></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display font-bold text-sm uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Get in Touch</h3>
          <ul className="space-y-3 text-sm text-[#D8E2DC]/80">
            <li className="flex items-center gap-2.5">
              <Phone size={15} className="text-[#D4AF37] shrink-0" />
              <a href="tel:+19709023321" data-testid="footer-phone" className="hover:text-white transition-colors duration-200">1-970-902-3321 — Iancu Alin</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone size={15} className="text-[#D4AF37] shrink-0" />
              <a href="tel:+12367770697" data-testid="footer-phone-secondary" className="hover:text-white transition-colors duration-200">+1 (236) 777-0697 — Matt Toews</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail size={15} className="text-[#D4AF37] shrink-0" />
              <a href="mailto:imrpoultrysolutions@gmail.com" data-testid="footer-email" className="hover:text-white transition-colors duration-200 break-all">imrpoultrysolutions@gmail.com</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Facebook size={15} className="text-[#D4AF37] shrink-0" />
              <a href="https://www.facebook.com/yanku.teberu.3/" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="hover:text-white transition-colors duration-200">Follow us on Facebook</a>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin size={15} className="text-[#D4AF37] shrink-0 mt-0.5" />
              <span data-testid="footer-address">2468 Waverly Dr, Blind Bay, BC V0E 1H2</span>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin size={15} className="text-[#D4AF37] shrink-0 mt-0.5" />
              <span data-testid="footer-service-area">Across British Columbia — anything outside a 100 km radius of Vancouver is charged per kilometre</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-7 text-center" data-testid="partner-strip">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#D4AF37]">Official Media &amp; Production Partner</p>
          <p className="mt-2 font-display font-extrabold text-lg tracking-wide">BEHIND SILENT EYES PRODUCTION LLC</p>
          <p className="mt-1 text-sm text-[#D8E2DC]/70">Proudly supporting IMR Poultry Solutions Inc.</p>
          <p className="mt-2 text-xs text-white/40 tracking-wide">Photography · Videography · Advertising · Promotional Content · Brand Development</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/40">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} IMR Poultry Solutions Inc. All rights reserved.</p>
          <p className="font-display font-semibold text-[#D4AF37]/70">Cleaner Barns. Stronger Farms.</p>
        </div>
      </div>
    </footer>
  );
};
